

class DateFormater {
    constructor(props) {
        this.date = props;
    }
    
    halfTime() {
        return this.date.toLocaleString('en-US',{
            hour12: false
        });
    }
    
    setCurrentAt(time) {
        let [cmonth, cday, cyear] = this.halfTime().split(',')[0].split('/'),
            [m, d, y] = time.split(',')[0].split('/');
        
        if (cyear > y) {
            let year = Math.floor(cyear - y);
            
            return `
                <span></span>&nbsp;${year}&nbsp;tahun yang lalu.
            `;
        }
        else if (cmonth > m) {
            let month = Math.floor(cmonth - m);
            
            return `
                <span></span>&nbsp;${month}&nbsp;bulan yang lalu.
            `;
        }
        else if (cday > d) {
            let day = Math.floor(cday - d);
            
            if (day >= 7) {
                return `
                    <span uk-icon="icon: world; ratio: 0.65"></span>&nbsp;satu minggu yang lalu.
                `;
            } else if (day >= 14) {
                return `
                    <span uk-icon="icon: world; ratio: 0.65"></span>&nbsp;dua minggu yang lalu.
                `;
            } else if (day >= 21) {
                return `
                    <span uk-icon="icon: world; ratio: 0.65"></span>&nbsp;tiga minggu yang lalu.
                `;
            } else {
                return `
                    <span uk-icon="icon: world; ratio: 0.65"></span>&nbsp;${day} hari yang lalu.
                `;
            }
        } else {
            let [hour, minutes, second] = time.split(',')[1].split(':');
            
            return {
                "hour": hour,
                "minutes": minutes,
                "second": second
            };
        }
    }
    
    setTimeCronJob(callback) {
        let finishMaintence = new Date(/*"May 7, 2021 00:00:00"*/).getTime();

        let timeLimit = setInterval(() => {
            let nowDate = new Date().getTime(),
                distance = /*finishMaintence - */nowDate,
                days = Math.floor(distance / (1000 * 60 * 60 * 24)),
                hour = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                seconds = Math.floor((distance % (1000 * 60)) / 1000);
            
            /**
             * Refresh otomatis
             * 
             *---------------------------------*
             | #       | Penjelasan            |
             *---------------------------------*
             | seconds | Setiap 1 menit sekali |
             | minutes | Setiap 1 jam sekali   |
             | hour    | Setiap 1 hari sekali  |
             | days    | Setiap 1 bulan sekali |
             *---------------------------------*
             */
            callback(seconds);
            
            if (distance < 0) {
                clearInterval(timeLimit);
            }
        }, 1000);
    }
    
    setCookieTime(exdays) {
        return this.date.setTime(
            this.date.getTime() + (exdays * 24 * 60 * 60 * 1000)
        );
    }
}

export default DateFormater;